var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goto--today",on:{"click":function($event){return _vm.gotoToday()}}},[_vm._v(" "+_vm._s((new Date()).getDate())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }